import { Controller } from '@hotwired/stimulus'
import type { GraphData } from '@app/application/report/screens/graphs-echarts/types'

export default class extends Controller {
  static values = {
    title: String,
    description: String,
  }

  static outlets = ['echarts-chart']

  declare titleValue: string
  declare descriptionValue: string
  declare echartsChartOutlet: { optionsValue: GraphData }

  open(): void {
    window.modalCitizen.openModalPortal('echarts-graph-modal', {
      title: this.titleValue,
      description: this.descriptionValue,
      graphData: this.echartsChartOutlet.optionsValue,
    })
  }
}
